import React from 'react';
import { createPortal } from 'react-dom';
import { BrandLogo } from '@/components/BrandLogo';

const FullscreenLoader = () => {
  const loaderContent = (
    <div className="fixed inset-0 bg-white dark:bg-gray-800 flex items-center justify-center z-[9999]">
      <div className="flex flex-col items-center">
        <BrandLogo
          className="h-16 w-auto max-w-[280px] object-contain animate-pulse"
          alt="Team Logistic Specialists"
        />
      </div>
    </div>
  );

  // Renderează loader-ul direct în document.body folosind portal
  return createPortal(loaderContent, document.body);
};

export default FullscreenLoader;